import { css } from "styled-components";
import { theme } from "../core/tokens";
import { aliasesTokens } from "../core/tokens/colors";
export const getThemeFont = (font) => {
    return (props) => props.theme.fonts[font || "sourceSansPro"];
};
export const getThemeFontSize = (size) => {
    return (props) => props.theme.fontSizes[size || "16"];
};
export const getThemeFontWeight = (weight) => {
    return (props) => props.theme.fontWeights[weight || "regular"];
};
export const getThemeLineHeight = (lineHeight) => {
    return (props) => props.theme.lineHeights[lineHeight || "tight"];
};
export const getThemeMedia = (bp) => {
    return (props) => props.theme.breakpoints[bp || "small"];
};
export const getThemeSpace = (space) => {
    return (props) => props.theme.space[space || "8"];
};
export const getThemeGutter = (type) => {
    const gutterVar = "var(--gutter)";
    const gutterType = {
        all: `margin: ${gutterVar}`,
        vertical: `margin-top: ${gutterVar}; margin-bottom: ${gutterVar}`,
        horizontal: `margin-left: ${gutterVar}; margin-right: ${gutterVar}`,
    };
    const gutter = gutterType[type || "all"] ? gutterType[type || "all"] : `margin-${type}: ${gutterVar}`;
    return css `
		--gutter: ${getThemeSpace("16")};

		@media screen and (min-width: ${getThemeMedia("medium")}) {
			--gutter: ${getThemeSpace("32")};
		}

		${gutter}
	`;
};
export const getThemeTokenParser = (data, target) => {
    if (!data)
        return "initial";
    // @ts-ignore
    if (typeof data === "string")
        return theme[target][data];
    // @ts-ignore
    return Object.entries(data).reduce(
    // @ts-ignore
    (acc, [key, value]) => ({ ...acc, [key]: theme[target][value] }), {});
};
export const getPropertyByMedia = (property, value, initialValue) => {
    const varName = `--prop-${property}`;
    const generateVar = (val) => (val ? `${varName}: ${val};` : "");
    const generateProperty = (val) => `${property}: ${val};`;
    if (typeof value === "object") {
        return css `
			${generateVar(value.small || initialValue)};

			@media screen {
				@media (min-width: ${getThemeMedia("small")}) {
					${generateVar(value.small)};
				}
				@media (min-width: ${getThemeMedia("medium")}) {
					${generateVar(value.medium)};
				}
				@media (min-width: ${getThemeMedia("large")}) {
					${generateVar(value.large)};
				}
			}

			${generateProperty(`var(${varName})`)}
		`;
    }
    if (value) {
        return css `
			${generateProperty(value)}
		`;
    }
    return css ``;
};
export const getColorPropertyByMedia = (property, value, initialValue) => {
    const varName = `--prop-${property}`;
    const generateVar = (val) => 
    // @ts-ignore
    val ? `${varName}: ${theme.colors[val]};` : "";
    const generateProperty = (val) => `${property}: ${val};`;
    if (typeof value === "object") {
        return css `
			${generateVar(value.small || initialValue)};

			@media screen {
				@media (min-width: ${getThemeMedia("small")}) {
					${generateVar(value.small)};
				}
				@media (min-width: ${getThemeMedia("medium")}) {
					${generateVar(value.medium)};
				}
				@media (min-width: ${getThemeMedia("large")}) {
					${generateVar(value.large)};
				}
			}

			${generateProperty(`var(${varName})`)}
		`;
    }
    if (value) {
        return css `
			${ /* @ts-ignore */generateProperty(theme.colors[value])}
		`;
    }
    return css ``;
};
export const getThemeShadow = (shadow) => {
    return (props) => props.theme.shadows[shadow || "1"];
};
export const getThemeAnimation = () => ({
    accordion: {
        openClose: (offset = "0px") => ({
            Root: `overflow: hidden;

		@keyframes slideDown {
			from {
				height: 0;
				opacity: 0;
			}
			to {
				height: calc(var(--radix-accordion-content-height) + ${offset});
				opacity: 1;
			}
		}

		@keyframes slideUp {
			from {
				height: calc(var(--radix-accordion-content-height) + ${offset});
				opacity: 1;
			}
			to {
				height: 0;
				opacity: 0;
			}
		}`,
            Content: `&[data-state='open'] {
			animation: slideDown 300ms ease-in-out;
		}

		&[data-state='closed'] {
			animation: slideUp 300ms ease-in-out;
		}`,
        }),
    },
    chevron: {
        rotate: (selector, attributeName, attributeValue, degrees) => ({
            Parent: `${selector} {
				transition: transform 300ms ease-in-out;
			}

			&[${attributeName}='${attributeValue.final}'] ${selector} {
				transform: rotate(${degrees}deg);
			}

			&[${attributeName}='${attributeValue.initial}'] ${selector} {
				transform: rotate(0);
			}`,
        }),
    },
});
export const generateCssVariables = (colorsToken) => {
    let cssVariables = "";
    Object.entries(colorsToken).forEach(([key, value]) => {
        cssVariables += `  ${key}: ${value};\n`;
    });
    return cssVariables;
};
export const getAliasesAsStyledTokens = () => {
    let styledTokens = {};
    Object.entries(aliasesTokens).forEach(([key, value]) => {
        styledTokens = {
            ...styledTokens,
            [key.replace("--", "")]: value,
        };
    });
    return styledTokens;
};
export const blueScrollBarStyles = (props) => css `
	&::-webkit-scrollbar {
		width: 8px !important;
		height: 8px !important;

		background-color: var(--surface-primary) !important;

		border: 4px solid var(--surface-white) !important;
		border-radius: 4px !important;
	}

	&::-webkit-scrollbar-track {
		margin: ${() => props?.track?.margin || '8px 0'} !important;
	}

	&::-webkit-scrollbar-thumb {
		background-color: var(--surface-accent) !important;

		border: 2px solid var(--surface-primary) !important;
		border-radius: 4px !important;
	}
`;
//# sourceMappingURL=helpers.js.map